import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AuthenticationService } from '../shared/services/authentication.service';
import { LANDING_NAV_ITEMS } from './nav-config';

@Component({
  selector: 'app-landing-nav-bar',
  standalone: true,
  imports: [RouterModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .nav-underline {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0;
        height: 2px;
        background: white;
        transition: width 0.25s ease, left 0.25s ease;
      }

      .landing-nav-link:hover .nav-underline,
      .landing-nav-active .nav-underline {
        width: 60%;
        left: 20%;
      }

      /* Hide horizontal scrollbar on the overflow container */
      .scrollbar-none::-webkit-scrollbar {
        display: none;
      }
      .scrollbar-none {
        scrollbar-width: none;
      }
    `,
  ],
  template: `
    @if (!loggedIn()) {
      <nav
        class="w-full bg-gradient-to-r from-[#357BBF] to-[#29B9E3]"
        [attr.aria-label]="'Landing pages' | translate"
      >
        <div
          class="max-w-[1440px] mx-auto px-4 lg:px-8 flex items-center gap-1 overflow-x-auto whitespace-nowrap scrollbar-none"
        >
          @for (item of items; track item.labelKey) {
            <a
              [routerLink]="item.route"
              routerLinkActive="landing-nav-active"
              class="landing-nav-link font-alternate text-base text-white px-3 py-2 relative"
            >
              {{ item.labelKey | translate }}
              <span class="nav-underline"></span>
            </a>
          }
        </div>
      </nav>
    }
  `,
})
export class LandingNavBarComponent {
  private authService = inject(AuthenticationService);
  private destroyRef = inject(DestroyRef);

  readonly loggedIn = signal(false);
  readonly items = LANDING_NAV_ITEMS;

  constructor() {
    this.authService.isAuthenticated$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((authenticated) => this.loggedIn.set(authenticated));
  }
}
